import React from "react";

import AddTab from "../../tabs/components/add-tab";

const PanelTabs = ({ addTab, changeTab, label, readOnly, selectedIndex, tabs }) => {
    const tabsHtml = tabs.map((tab, index) => {
        const tabName = tab.text || `Panel ${index + 1}`;
        const tabClass = index === Number(selectedIndex) ? "tab -active" : "tab";

        return (
            <button
                key={`tab_${index}`}
                data-index={index}
                className={tabClass}
                onClick={() => {
                    changeTab(index);
                }}
            >
                {tabName}
            </button>
        );
    });

    return (
        <div className="tab-container">
            <div className="tab-list -thick -align">
                {tabsHtml}
                {!readOnly && (
                    <AddTab
                        addTab={addTab}
                        label={label}
                    />
                )}
            </div>
        </div>
    );
};

PanelTabs.defaultProps = {
    label: "Panel",
};

export default PanelTabs;
